import { FeatureNames, HemsFlattenedFeatures, HemsProperties } from '@vi-iot/client';

import { SUFFIX, Unit } from '../../shared/common/units';

export enum HemsUnitGroup {
  Percent = 'percent',
  WkWh = 'W/kWh',
  Kg = 'kg',
}

export const hemsPropertiesUnits: { property: HemsProperties; unit: HemsUnitGroup }[] = [
  { property: FeatureNames.kpiAutarky, unit: HemsUnitGroup.Percent },
  { property: FeatureNames.kpiSelfConsumption, unit: HemsUnitGroup.Percent },
  { property: FeatureNames.energyProductionTotal, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.energyConsumptionTotal, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.energyHeatPumpConsumption, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.energyHouseholdConsumption, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.emsCarbonSavings, unit: HemsUnitGroup.Kg },
  { property: FeatureNames.emsCarbonEmissions, unit: HemsUnitGroup.Kg },
  { property: FeatureNames.energyGridConsumption, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.energyGridFeedIn, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.energyBatteryStateOfCharge, unit: HemsUnitGroup.Percent },
  { property: FeatureNames.energyBatteryCharge, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.energyBatteryDischarge, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.emsEnergyConsumptionVcs, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.heatPumpConsumption, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.compressorConsumption, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.electricHeaterConsumption, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.heatingConsumption, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.hotWaterConsumption, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.coolingConsumption, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.thermalOutputTotal, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.heatingOutput, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.hotWaterOutput, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.coolingOutput, unit: HemsUnitGroup.WkWh },
  { property: FeatureNames.emsEnergyProductionToConsumption, unit: HemsUnitGroup.WkWh },
];

export interface HemsHistoricalData {
  gateway_id: string;
  device_id: string;
  resolution: string;
  timeframe: string;
  properties: string[];
  summary_properties: {
    [key in HemsProperties]: Unit;
  };
  timeseries_properties: {
    [key in HemsProperties]: Unit;
  };
  data: {
    summary: {
      [key: string]: number;
    };
    timeseries: {
      [key: string]: number | string;
      timestamp: string;
    }[];
  };
}

export interface SelectableFeature {
  name: HemsProperties;
  displayName: string;
  checked: boolean;
  unit?: SUFFIX.percentage | SUFFIX.kilogram | SUFFIX.kilowattHour;
}

export interface EnergyHistoricalDataFeaturesGroup {
  groupKey: string;
  features: HemsFlattenedFeatures[];
}

export interface SelectableFeaturesGroup {
  groupKey: string;
  features: SelectableFeature[];
}

export interface LegendFeature {
  feature: string;
  color: string;
}

export interface SavedSelectedFeature {
  [key: string]: {
    electricitySelectedFeatures: HemsProperties[];
    heatingSelectedFeatures: HemsProperties[];
  };
}
